/* eslint-disable no-use-before-define */
import React from 'react'
import {
    CartesianGrid,
    ResponsiveContainer,
    BarChart,
    Bar,
    Cell,
    XAxis,
    YAxis,
} from 'recharts'

const COLORS = [
    '#8B06B9', // muni-in
    '#2320BB', // muni-out
    '#1192E9', // corp
    '#00A3A0', // treasury
]

const SHORT_LABELS = {
    muni_in: 'In-state muni',
    muni_out: 'Out-of-state muni',
    corp: 'Corporate',
    tsy: 'Treasury',
}

const pct2 = (a) => {
    let x = Number.parseFloat(a)
    return isNaN(x) ? '-' : (x.toFixed(2) + '%')
}


let XAxisTick = (props) => {
    const { x, y, width, index, data } = props

    let value = data[index] || {}
    let color = COLORS[index]
    let label = SHORT_LABELS[value.name]
    let w = Math.max(width/4 - 25, 65)

    return <React.Fragment>
        <foreignObject x={x-w/2+5} y={y+1} width={w} height={30}>
        <div style={{
            height: 35,
            fontSize: '11px',
            borderLeft: `5px solid ${color}`,
            paddingLeft: '5px',
            lineHeight: 'normal',
        }}>{label}</div>
        </foreignObject>
        </React.Fragment>

}

export const Chart = ({calculation}) => {
    let { order, values } = calculation || {}
    if (!order || !values) return null

    let vs = values[3]
    let data = order
        .map((a) => ({
            name:a,
            value:vs[a] * 100
        }))

    let maxValue = data.reduce( (x, a) => a.value > x ? a.value : x, 0)

    return <ResponsiveContainer width="100%" height={275} >
    <BarChart
        margin={{bottom:25}}
        data={data}
    >
        <CartesianGrid vertical={false} />
        <YAxis
            domain={[
                0,
                dataMax => {
                    let m = Math.ceil(dataMax)
                    let y = m > 100 ? m + Math.ceil(m/25) * 2
                        : m > 20 ? m + Math.ceil(m/20) * 2
                        : m > 12 ? m + 2
                        : m > 5 ? m + 1
                        : m > 3 ? m + 0.75
                        : m > 2 ? m + 0.5
                        : m > 1 ? m + 0.25
                        : m > 0.5 ? m + 0.125
                        : m
                    return y
                }
            ]}
            orientation={'right'}
            unit='%'
            axisLine={false}
            tickLine={false}
            tickCount={4}
            scale='linear'
            width={Math.ceil(maxValue) > 90 ? 45 : 35}
        />
        <XAxis
            tickLine={false}
            tick={<XAxisTick data={data} />}
        />
        <Bar
            dataKey={'value'}
            label={{
                formatter: pct2,
                value:'value',
                position:'top',
                stroke: 'none',
                fill: '#666',
                fontSize: '13px',
                fontWeight: 400,
            }}
        >
            {data.map( (e,i) => <Cell
                key={`cell-${i}`}
                fill={COLORS[i]}
                stroke={'#e9e9e9'}
            />) }

       </Bar>

    </BarChart>

    </ResponsiveContainer>
}
